
    import { defineComponent } from 'vue'
    import Listbox from 'primevue/listbox'
    import metadataDefinitionTabViewDescriptor from './MetadataDefinitionTabViewDescriptor.json'

    export default defineComponent({
        name: 'measure-definition-filter-list',
        components: { Listbox },
        props: { header: { type: String }, list: { type: Array }, listType: { type: String } },
        emits: ['selected'],
        data() {
            return {
                metadataDefinitionTabViewDescriptor,
                filters: [],
                sorted: 'DESC'
            }
        },
        computed: {
            iconClass(): String {
                return this.sorted === 'DESC' ? 'pi pi-arrow-down' : 'pi pi-arrow-up'
            }
        },
        watch: {
            list() {
                this.loadList()
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                this.filters = this.list as any
            },
            sortArray() {
                if (this.sorted === 'DESC') {
                    this.filters = this.filters.sort((a: any, b: any) => (a.name > b.name ? 1 : -1))
                    this.sorted = 'ASC'
                } else {
                    this.filters = this.filters.sort((a: any, b: any) => (a.name < b.name ? 1 : -1))
                    this.sorted = 'DESC'
                }
            }
        }
    })
